import { useEffect, useState, VFC } from 'react'
import ReactSlick, { Settings as ReactSlickSettings } from 'react-slick'
import { createMyPageActionLog } from 'src/api/mypage'
import { Link } from 'src/elements/Link'
import { Event } from 'src/models/Event'
import { _contributiontext, mediumGray, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { WIDTH_THRESHOLD } from 'src/styles/mixins'
import { eventDetail, EVENTS } from 'src/utils/routes'
import styled from 'styled-components'

type EventsProps = {
  events: Event[]
}
export const MyPageEvents: VFC<EventsProps> = ({ events }) => {
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isTab = width < WIDTH_THRESHOLD
  const slidesToShowCount = isTab ? 1 : 5
  const slidesToShow = Math.min(slidesToShowCount, events.length)

  const settings: ReactSlickSettings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    initialSlide: -1,
    variableWidth: true,
  }

  const onClick = (id: number) => {
    createMyPageActionLog({
      component: 'MyPageEvents',
      item: 'event',
      targetObjectId: id,
    })
  }
  return (
    <>
      <EventsLayout>
        <Container>
          <Top>
            <Title>決裁者つながりイベント・セミナー開催中</Title>
            <TitleSub href={EVENTS}>
              <p>一覧はこちら　▶︎</p>
            </TitleSub>
          </Top>
        </Container>

        <ReactSlick arrows={false} slidesToShow={slidesToShow} {...settings}>
          {events.map((event) => (
            <ContentLink
              key={event.id}
              href={eventDetail(event.id)}
              onClick={() => onClick(event.id)}
            >
              <ContentDiv>
                <Image src={event.imageFile.url} alt="" />
                <Text>{event.openingAt.format('YYYY/MM/DD HH:mm')}〜</Text>
              </ContentDiv>
            </ContentLink>
          ))}
        </ReactSlick>
      </EventsLayout>
    </>
  )
}

const EventsLayout = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 40px auto;

  .slick-track {
    display: flex;
  }
`
const Container = styled.div``
const Top = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`

const Title = styled.h1`
  color: ${mediumGray};
  font-weight: ${fontWeightBold};
  text-align: center;
  margin-bottom: 20px;

  font-size: 32px;
  @media screen and (max-width: 960px) {
    font-size: 20px;
    max-width: 260px;
  }
`
const TitleSub = styled(Link)`
  position: absolute;
  top: 0px;
  right: 0px;

  text-align: center;
  line-height: 32px;
  font-weight: ${fontWeightBold};
  color: ${_contributiontext};
  display: flex;
  justify-content: center;
  p {
    margin-right: 8px;
  }
  @media screen and (max-width: 960px) {
    top: 250px;
  }
`
const ContentLink = styled(Link)`
  cursor: pointer;
  height: 200px;
  max-width: 247px;
  min-width: 247px;
  margin: 0 8px;
`
const ContentDiv = styled.div`
  border-radius: 10px;
  background-color: ${truewhite};
  box-shadow: 0px 10px 30px 0px #00000029;
`
const Image = styled.img`
  width: 247px;
  height: 140px;
  padding-top: 8px;
  object-fit: contain;
`
const Text = styled.p`
  height: 29px;
  line-height: 29px;
  text-align: right;
  padding: 0 8px;
`
